/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

export const GOLDEN_ACCESS_PASS = 'Golden Access Pass';

export const GOLDEN_AGE_PASS = 'Golden Age Pass';

export const INTERAGENCY_ACCESS_PASS = 'Interagency Access Pass';

export const INTERAGENCY_ANNUAL_SENIOR_PASS = 'Interagency Annual Senior Pass';

export const INTERAGENCY_LIFETIME_SENIOR_PASS = 'Interagency Lifetime Senior Pass';

export const MILITARY_PASS = 'Military Discount';

export const TRIBAL_WAIVER = 'Tribal Discount';

/* Default pass structure for submission */
export const emptyPass = {
    pass_type: '',
    pass_number: '',
};

/* List of pass types that doesn't require an associated pass number to apply */
export const PASSES_WITHOUT_PASS_NUMBER = [MILITARY_PASS, TRIBAL_WAIVER];

export const INTERAGENCY_PASSES = [
    INTERAGENCY_ACCESS_PASS,
    INTERAGENCY_ANNUAL_SENIOR_PASS,
    INTERAGENCY_LIFETIME_SENIOR_PASS,
];
